import React, { useState } from 'react';
import { Dropdown } from 'flowbite-react';
import { UIApplicationCardState, UIExtendedApplication } from 'types';
import {
	optOutOfApplicationProcess,
	requestInterviewReschedule,
	requestOptingOutOfApplicationProcess,
} from 'src/apis/application';
import { useMutation, useQueryClient } from 'react-query';
import { useToast } from 'src/context/ToastProvider';
import OptOutModal from './OptOutModal';
import classNames from 'classnames';
import { BsThreeDots } from 'react-icons/bs';
import { HiOutlineCalendar, HiOutlineLogout } from 'react-icons/hi';
import { PROFILE_MENU_CLASS, PROFILE_MENU_DANGER_ITEM_CLASS, PROFILE_MENU_ITEM_CLASS } from 'src/components/shared/profileMenuStyles';

interface Props {
	applicationCardState: UIApplicationCardState;
	application: UIExtendedApplication;
}

const ThreeDotMenu = ({ applicationCardState, application }: Props) => {
	const [showOptOutModal, setShowOptOutModal] = useState(false);

	const toast = useToast();
	const queryClient = useQueryClient();
	const [requestOptingOutOfApplicationProcessLoading, setRequestOptingOutOfApplicationProcessLoading] = useState(false);
	const [requestInterviewRescheduleLoading, setRequestInterviewRescheduleLoading] = useState(false);

	const requestOptingOutOfApplicationProcessMutation = useMutation(
		['optOutOfApplicationProcess'],
		requestOptingOutOfApplicationProcess,
		{
			onSuccess() {
				toast({
					title: 'You have successfully requested to opt out of the application process',
					type: 'success',
				});
				queryClient.refetchQueries(['getAllApplications']);
				setRequestOptingOutOfApplicationProcessLoading(false);
			},
			onError(error: Error) {
				setRequestOptingOutOfApplicationProcessLoading(false);
				toast({
					title: `Error while requesting opt out of the application process: ${error.message}`,
					type: 'error',
				});
			},
		},
	);
	const requestInterviewRescheduleMutation = useMutation(['optOutOfApplicationProcess'], requestInterviewReschedule, {
		onSuccess() {
			toast({
				title: 'You have successfully requested for the interview to be reschedule',
				type: 'success',
			});
			queryClient.refetchQueries(['getAllApplications']);
			setRequestInterviewRescheduleLoading(false);
		},
		onError(error: Error) {
			setRequestInterviewRescheduleLoading(false);
			toast({
				title: `Error while requesting reschedule from interview process: ${error.message}`,
				type: 'error',
			});
		},
	});
	const [optOutReason, setOptOutReason] = useState<string>('');
	return (
		<>
			<div
				onClick={e => {
					e.stopPropagation();
				}}
				className={`[&_div[data-testid='flowbite-dropdown']]:!border-gray-200 dark:[&_div[data-testid='flowbite-dropdown']]:!border-gray-600 `}
			>
				<Dropdown
					dismissOnClick
					placement="bottom-end"
					arrowIcon={false}
					inline={true}
					color={'#C7C9D9'}
					className={PROFILE_MENU_CLASS}
					label={
						<span aria-label="More options" className="flex h-9 w-9 items-center justify-center rounded-full text-[#555770] transition-colors hover:bg-[#ECECF3] dark:text-gray-300">
							<BsThreeDots className="h-5 w-5" />
						</span>
					}
				>
					{applicationCardState === UIApplicationCardState.INTERVIEW_ROUND_IN_PROGRESS_CARD && (
						<Dropdown.Item
							className={PROFILE_MENU_ITEM_CLASS}
							onClick={() => {
								requestInterviewRescheduleMutation.mutate({
									applicationId: application._id || '',
									userId: application.user?._id || '',
									remarks: 'Test remarks for interview!',
								});
							}}
							disabled={requestInterviewRescheduleLoading}
						>
							<HiOutlineCalendar className="h-[18px] w-[18px] text-[#8A8BA3]" />
							Request reschedule
						</Dropdown.Item>
					)}
					<Dropdown.Item
						className={PROFILE_MENU_DANGER_ITEM_CLASS}
						disabled={requestOptingOutOfApplicationProcessLoading}
						onClick={() => {
							setShowOptOutModal(true);
						}}
					>
						<HiOutlineLogout className="h-[18px] w-[18px]" />
						Opt out
					</Dropdown.Item>
				</Dropdown>
			</div>
			<OptOutModal
				isOpen={showOptOutModal}
				onClose={() => {
					setShowOptOutModal(false);
				}}
				optOutReason={optOutReason}
				setOptOutReason={setOptOutReason}
				application={application}
				requestOptingOutOfApplicationProcessMutation={requestOptingOutOfApplicationProcessMutation}
			/>
		</>
	);
};

export default ThreeDotMenu;
